export default function validateObjectValue(data) {
  if (typeof data !== 'object') return;
  /* Check if object has any item with a valid value */
  let hasAtLeastOneValid = Object.values(data).some(value => {
    let result = value;
    if (value && typeof value === 'object') {
      result = Object.keys(value).length !== 0;
    } else if (value === 0) {
      return true;
    }
    return result;
  });
  return hasAtLeastOneValid;
}
